exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".form-group{margin-bottom:-2em}.table-responsive{max-height:29em}.ooiv{font-size:small;margin-bottom:revert}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/bulk-action/bulk-action-popup/bulk-action-popup.component.css"],"names":[],"mappings":"AAAA,YACE,kBAAoB,CACrB,kBAEC,eAAiB,CAClB,MAEC,gBAAiB,oBACK,CACvB","file":"bulk-action-popup.component.css","sourcesContent":[".form-group {\n  margin-bottom: -2em;\n}\n.table-responsive {\n  max-height: 29em;\n}\n.ooiv {\n  font-size: small;\n  margin-bottom: revert;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/bulk-action/bulk-action-popup/bulk-action-popup.component.css
// module id = ISUr
// module chunks = 0